var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "window" }, [
        _c("p", [_vm._v("window width: " + _vm._s(_vm.width))]),
        _vm._v(" "),
        _c("p", [_vm._v("window height: " + _vm._s(_vm.height))])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("router-link", { attrs: { to: "/login" } }, [
        _c("div", [
          _c("img", {
            staticClass: "login-img",
            attrs: {
              src: require("@/assets/top/アセット 2@2x.png"),
              width: "1942",
              height: "347",
              loading: "lazy"
            }
          })
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-title" }, [
      _c("img", {
        staticClass: "title",
        attrs: {
          src: require("@/assets/top/LASHIC_healthlab_logo.png"),
          width: "1880",
          height: "203",
          loading: "lazy"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c25d783e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c25d783e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Top.vue
// module id = null
// module chunks = 